import styled from "styled-components";
import {Accessibility} from "@FRAMEWORK/ui/mobile/text";

const HeaderWrap = styled.header<{$isNotFixed?: boolean}>`
	position: ${props => (props.$isNotFixed ? "relative" : "sticky")};
	top: 0;
	z-index: 15;
	background-color: #fff;
	box-sizing: border-box;

	h1 {
		margin: 0;
	}

	h1 a {
		display: block;
		height: 30px;
	}

	h2 {
		color: #222;
		font-family: "PT-bold";
		font-size: 21px;
		letter-spacing: normal;
	}

	img {
		vertical-align: top;
		width: 100%;
		height: 100%;
	}
`;

const Wrap = styled.div`
	display: flex;
	align-items: center;
	height: 60px;
	padding: 0 15px;
	border-bottom: 1px solid #ddd;
`;

const BtnBack = styled.button`
	width: 20px;
	height: 20px;
	margin-right: 15px;
	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -17px 0 / 150px 50px no-repeat;
`;

const BtnCategory = styled.button`
	position: relative;
	padding-right: 21px;

	&::after {
		position: absolute;
		top: 7px;
		right: 2px;
		display: inline-block;
		width: 8px;
		height: 8px;
		border-top: 2px solid #222;
		border-right: 2px solid #222;
		transform: rotate(135deg);
		content: "";
	}
`;

const BtnMain = styled.a`
	display: inline-block;
	width: 22px;
	height: 24px;
	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -40px 0 / 150px 50px no-repeat;
`;

const BtnLike = styled.button<{isActive?: boolean}>`
	display: inline-block;
	width: 23px;
	height: 24px;
	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -65px 0 / 150px 50px no-repeat;
	cursor: pointer;

	${props =>
		props.isActive &&
		`
        background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) 0px -25px / 150px 50px no-repeat;
    `}
`;

const BtnShare = styled.button`
	display: inline-block;
	width: 24px;
	height: 24px;
	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -90px 0 / 150px 50px no-repeat;
	cursor: pointer;

	&:active {
		background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -25px -25px / 150px 50px no-repeat;
	}
`;

const BtnGroup = styled.div`
	display: flex;
	align-content: center;
	gap: 10px;
	margin-left: auto;
`;

const TopBanner = styled.div`
	position: relative;

	img {
		width: 100%;
		vertical-align: top;
	}

	a {
		display: block;
	}
`;

const BtnBannerClose = styled.button`
	position: absolute;
	right: 15px;
	top: 50%;
	width: 22px;
	height: 22px;
	padding: 0;
	margin: 0;
	border: 0;
	background: none;
	transform: translateY(-50%);

	&::before,
	&::after {
		position: absolute;
		right: 0;
		height: 1px;
		width: 20px;
		background: #000;
		border-radius: 1px;
		content: "";
	}

	&::before {
		transform: rotate(45deg);
	}

	&::after {
		transform: rotate(-45deg);
	}
`;

const Header = () => (
	<>
		{/* 타입 2 */}
		<HeaderWrap>
			<TopBanner>
				<a href="#">
					<img src="https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner_m.jpg" alt="배너 이미지" />
				</a>
				<BtnBannerClose type="button">
					<span className="blind-ir">배너 닫기</span>
				</BtnBannerClose>
			</TopBanner>
			<Wrap>
				<BtnBack type="button">
					<span>뒤로가기</span>
				</BtnBack>
				<BtnCategory type="button">
					<h2>카테고리</h2>
				</BtnCategory>
			</Wrap>
		</HeaderWrap>
		{/* 타입 3 */}
		<HeaderWrap>
			<Wrap>
				<BtnBack type="button">
					<span>뒤로가기</span>
				</BtnBack>
				<h2>페이지명</h2>
				<BtnGroup>
					<BtnMain href="https://m.ybtour.co.kr/index.yb">
						<Accessibility>메인 페이지로 이동</Accessibility>
					</BtnMain>
				</BtnGroup>
			</Wrap>
		</HeaderWrap>
		{/* 타입 4 */}
		<HeaderWrap>
			<Wrap>
				<BtnBack type="button">
					<span>뒤로가기</span>
				</BtnBack>
				<h2>페이지명</h2>
				<BtnGroup>
					<BtnMain href="https://m.ybtour.co.kr/index.yb">
						<Accessibility>메인 페이지로 이동</Accessibility>
					</BtnMain>
					<BtnLike type="button">
						<span>찜한 상품</span>
					</BtnLike>
					<BtnShare type="button">
						<span>공유하기</span>
					</BtnShare>
				</BtnGroup>
			</Wrap>
		</HeaderWrap>
		{/* 타입 4 - on */}
		<HeaderWrap>
			<Wrap>
				<BtnBack type="button">
					<span>뒤로가기</span>
				</BtnBack>
				<h2>페이지명</h2>
				<BtnGroup>
					<BtnMain href="https://m.ybtour.co.kr/index.yb">
						<Accessibility>메인 페이지로 이동</Accessibility>
					</BtnMain>
					<BtnLike type="button" isActive={true}>
						<span>찜한 상품</span>
					</BtnLike>
					<BtnShare type="button">
						<span>공유하기</span>
					</BtnShare>
				</BtnGroup>
			</Wrap>
		</HeaderWrap>
	</>
);

export {BtnBack, BtnCategory, BtnGroup, BtnLike, BtnMain, BtnShare, HeaderWrap, Wrap};
export default Header;
